
const SUCCESS = 'Success';
const NO_DATA = 'NoData';
const FAIL = "Fail";

export default {SUCCESS,NO_DATA,FAIL}
